import { useEffect, useState } from "react";
import ImageUploader2 from "./ImageUploader2";
import Resizer from "react-image-file-resizer";
import { Field, Form as FinalForm } from "react-final-form";
import Swal from "sweetalert2";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";

const AddCouponForm = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    formData,
    setFormData,
    refetch,
    getCouponList,
  } = props;

  const token = localStorage.getItem("token");

  const handleUpload = async () => {

  requestAnimationFrame(async () => {

    try {
      const couponResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}save-coupon`,
        formData,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      getCouponList();

      alert("Coupon saved successfully!");
      setShowModal(false);

    } catch (error) {
      console.error("Error in uploading image or saving coupon:", error);
      alert("An error occurred. Please try again!");
    }
  });
};

  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Coupon Name
        </label>
        <input
          type="text"
          name="coupon_name"
          placeholder="Coupon Name"
          value={formData.coupon_name}
          onChange={(e) =>
            setFormData({
              ...formData,
              coupon_name: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>

      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Coupon Code
        </label>
        <input
          type="text"
          name="coupon_code"
          placeholder="Coupon Code"
          value={formData.coupon_code}
          onChange={(e) =>
            setFormData({
              ...formData,
              coupon_code: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>

      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Coupon Amount Type
        </label>
        <select
          name="coupon_amount_type"
          value={formData.coupon_amount_type}
          onChange={(e) =>
            setFormData({
              ...formData,
              coupon_amount_type: e.target.value,
            })
          }
          className="select select-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] rounded-xl bg-white"
        >
          <option value="">Select Type</option>
          <option value="fixed">Fixed</option>
          <option value="percentage">Percentage</option>
        </select>
      </div>

      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Amount Limit
        </label>
        <input
          type="number"
          name="amount_limit"
          placeholder="Amount Limit"
          value={formData.amount_limit}
          onChange={(e) =>
            setFormData({
              ...formData,
              amount_limit: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] rounded-xl bg-white"
        />
      </div>

      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Amount
        </label>
        <input
          type="number"
          name="amount"
          placeholder="Amount"
          value={formData.amount}
          onChange={(e) =>
            setFormData({
              ...formData,
              amount: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>

      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Minimum Order Amount
        </label>
        <input
          type="number"
          name="minimum_order_amount"
          placeholder="Minimum Order Amount"
          value={formData.minimum_order_amount}
          onChange={(e) =>
            setFormData({
              ...formData,
              minimum_order_amount: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Usage limit
        </label>
        <input
          type="number"
          name="usage_limit"
          placeholder="Usage limit"
          value={formData.usage_limit}
          onChange={(e) =>
            setFormData({
              ...formData,
              usage_limit: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Customer Usage Limit
        </label>
        <input
          type="number"
          name="customer_usage_limit"
          placeholder="Customer Usage Limit"
          value={formData.customer_usage_limit}
          onChange={(e) =>
            setFormData({
              ...formData,
              customer_usage_limit: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] font-semibold bg-white px-1 -top-2 left-3 z-10">
          Expire Date
        </label>
        <DatePicker
          selected={formData.expire_date}
          onChange={(date) =>
            setFormData({
              ...formData,
              expire_date: date,
            })
          }
          dateFormat="yyyy-MM-dd"
          placeholderText="Select expire date"
          className=" w-full border border-gray-300 rounded px-3 py-[10px] text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
      <div className="flex items-center gap-3 mt-2">
        <input
          type="checkbox"
          checked={formData.new_user_only}
          onChange={(e) =>
            setFormData({
              ...formData,
              new_user_only: e.target.checked,
            })
          }
          className="checkbox checkbox-primary"
        />
        <label className="font-nunito text-sm text-[#102048] font-semibold">
          New User Only
        </label>
      </div>
      <div className="flex flex-col mt-2">
        <div className="w-full relative mt-2">
            <label className="absolute font-nunito text-xs text-[#102048] left-[12px] top-[-7px] bg-white px-1 font-semibold">
              Description
            </label>
            <div className="mt-4">
              <ReactQuill
                value={formData.description || ""}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    description: value,
                  })
                }
                className="bg-white"
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", "image"],
                    ["clean"],
                  ],
                }}
                formats={[
                  "header",
                  "bold",
                  "italic",
                  "underline",
                  "strike",
                  "list",
                  "bullet",
                  "link",
                  "image",
                ]}
              />
            </div>
          </div>

          <div>
            <button
              onClick={() => handleUpload()}
              className="cursor-pointer w-full mt-4 bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
            >
              Done
            </button>
          </div>
      </div>
    </div>
  );
};

export default AddCouponForm;
